export const BREEDPLAN_INTERPRETING_EBVS_URL =
  'https://breedplan.une.edu.au/getting-started/a-breedplan-guide-to-interpreting-ebvs-with-video/';

export const BREEDPLAN_ANIMAL_SELECTION_URL =
  'https://breedplan.une.edu.au/using-selection-indexes/a-breedplan-guide-to-animal-selection-with-video/';
